<template>
  <row-card class="jobseeker-card"
    :imageUrl="imageUrl"
    :leftTitle="name"
    :leftSubtitle="locations"
    :rightTitle="role"
    :rightSubtitle="company"
    @click="onClick">
  </row-card>
</template>

<script>
import RowCard from '@/components/general/row-card'

export default {
  components: { RowCard },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageUrl () {
      return this.user.profilePictureUrl || `/api/identicons/${this.user.id}`
    },
    name () {
      const user = this.user
      const firstName = user.firstName || ''
      const lastName = user.lastName || ''
      return `${firstName} ${lastName}`
    },
    locations () {
      return this.user.location || ''
    },
    role () {
      return this.user.role || ''
    },
    company () {
      return this.user.companyName || ''
    }
  },
  methods: {
    onClick (event) {
      this.$emit('click', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/user-row-card.vue